import { Component, OnInit, Input } from '@angular/core';
import { Message } from '../../../../../models/message';
import { ChatMessageService } from '../../../../services/data/messages/chat-message/chat-message.service';

import * as _ from 'lodash';
import { LocationService } from '../../../../../utilities/location/location.service';
import { MessageTypeConstant } from '../../../../../constants/message-type.constant';
import { AttachmentTypeConstant } from '../../../../../constants/attachment-type.constant';
import { FileManagerService } from '../../../../../utilities/file-manager/file-manager.service';

@Component({
  selector: 'tn-message-parent',
  templateUrl: './message-parent.component.html',
  styleUrls: ['./message-parent.component.scss']
})
export class MessageParentComponent implements OnInit {

  @Input() message: Message;
  @Input() isSentByMe: boolean;
  // Opt-in leading type icon (camera / mic / map pin ...), used by the pinned banner.
  // Off by default so reply previews keep their existing look.
  @Input() isShowTypeIcon: boolean;
  MSG_TYPE = MessageTypeConstant

  attachmentType: number;
  ATTACHMENT_TYPE = AttachmentTypeConstant;

  imgSrc: string;
  typeIconClass: string;

  constructor(
    private _chatMessageService: ChatMessageService,
    private _fileManagerService: FileManagerService,
    private _locationService: LocationService
  ) { }

  ngOnInit() {
  }

  ngOnChanges() {
    this.parseReplyMessage();
  }

  parseReplyMessage() {
    this.message = this._chatMessageService.getSingleParsedMsg(this.message);
    this.typeIconClass = null;
    switch (_.toInteger(this.message.type)) {
      case this.MSG_TYPE.TEXT:
        break;
      case this.MSG_TYPE.ATTACHMENT:
        let attachment = this.message.attachments[0];
        this.attachmentType = this._fileManagerService.getAttachmentType(attachment.attachment_id);

        switch (this.attachmentType) {
          case this.ATTACHMENT_TYPE.IMAGE:
          case this.ATTACHMENT_TYPE.VIDEO:
            this.imgSrc = this._fileManagerService.getBackgroundImgSrcByBase64(attachment.preview_image, attachment.content_type);
            break;
          case this.ATTACHMENT_TYPE.PDF:
            
            break;
        }

        break;
      case this.MSG_TYPE.LOCATION:
        this.imgSrc = this._locationService.getLocationPreviewSrc(this.message.parsedBody.latitude, this.message.parsedBody.longitude);
        break;
      case this.MSG_TYPE.STICKER:
        this.imgSrc = this._fileManagerService.getBackgroundImgSrcByAttachmentId(this.message.parsedBody.attachment_id);
        break;
    }

    this.typeIconClass = this.getTypeIconClass();
  }

  /**
   * A poll has no body text of its own to preview, so the question stands in for it.
   */
  private getTypeIconClass(): string {
    switch (_.toInteger(this.message.type)) {
      case this.MSG_TYPE.ATTACHMENT:
        switch (this.attachmentType) {
          case this.ATTACHMENT_TYPE.IMAGE:
            return 'fa-camera';
          case this.ATTACHMENT_TYPE.VIDEO:
            return 'fa-video-camera';
          case this.ATTACHMENT_TYPE.AUDIO:
            return 'fa-microphone';
          default:
            return 'fa-file-o';
        }
      case this.MSG_TYPE.LOCATION:
        return 'fa-map-marker';
      case this.MSG_TYPE.STICKER:
        return 'fa-smile-o';
      case this.MSG_TYPE.CHAT_POLL:
        return 'fa-bar-chart';
    }
    return null;
  }
}
